import amplitude from 'amplitude-js';

import Dispatcher from '../Dispatcher';

const getAPIKey = () => {
  switch (process.env.REACT_APP_STAGE) {
    case 'prod':
      return '73a202f660f578c76925830a180cebbb';
    case 'staging':
      return '73544149b07299c8d89a57a01414843b';
    case 'integration':
      return '9a9a98f21490e2d25b81998986fa79b6';
    case 'development':
      // Uncomment to test instrumentation in Amplitude
      // return '39c7199aa67429d2eab17c0713f2330e';
      return null;
    default:
      return null;
  }
};

const enablementFilter = {
  isDisabled: !getAPIKey(),
};

Dispatcher.registerInit(enablementFilter, () => {
  amplitude.getInstance().init(getAPIKey());
});

Dispatcher.registerIdentify(enablementFilter, ({ userId, properties }) => {
  if (userId) {
    amplitude.getInstance().setUserId(userId);
  }

  if (properties?.visitorSessionUUID) {
    amplitude.getInstance().setDeviceId(properties.visitorSessionUUID);
  }

  if (Object.keys(properties).length) {
    amplitude.getInstance().setUserProperties(properties);
  }
});

Dispatcher.registerLogEvent(enablementFilter, ({ eventName, eventProperties }) => {
  amplitude.getInstance().logEvent(eventName, eventProperties);
});

Dispatcher.registerLogPage(enablementFilter, ({ eventName, eventProperties }) => {
  amplitude.getInstance().logEvent('Page Viewed', { ...eventProperties, page: eventName });
});
